import * as TypeGraphQL from "type-graphql";
export var NewsArticleAssetSentimentScalarFieldEnum;
(function (NewsArticleAssetSentimentScalarFieldEnum) {
    NewsArticleAssetSentimentScalarFieldEnum["id"] = "id";
    NewsArticleAssetSentimentScalarFieldEnum["assetId"] = "assetId";
    NewsArticleAssetSentimentScalarFieldEnum["newsArticleId"] = "newsArticleId";
    NewsArticleAssetSentimentScalarFieldEnum["url"] = "url";
    NewsArticleAssetSentimentScalarFieldEnum["relevancyScore"] = "relevancyScore";
    NewsArticleAssetSentimentScalarFieldEnum["sentimentScore"] = "sentimentScore";
    NewsArticleAssetSentimentScalarFieldEnum["sentimentLabel"] = "sentimentLabel";
})(NewsArticleAssetSentimentScalarFieldEnum || (NewsArticleAssetSentimentScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(NewsArticleAssetSentimentScalarFieldEnum, {
    name: "NewsArticleAssetSentimentScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=NewsArticleAssetSentimentScalarFieldEnum.js.map